/**
 * Created by Administrator on 2018/12/25.
 */
// import global from './global'
const myFilters = {
  imgListPathFilter: function (imglist) {
    let newImgList=[];
    let ImgBaseURL="http://122.114.130.217:8083/";
    for (let img of imglist) {
      newImgList.push(ImgBaseURL+'/'+img)
    }
    return newImgList;
  },
  imgPathFilter: function (img) {
    let ImgBaseURL="http://122.114.130.217:8083/";
    return ImgBaseURL+'/'+img;
  },
  timeFilter:function(time){
    if(time !== ''&& time !== undefined && time !== null) {
      return time.substring(0, 10)
    }
  },
}

export default myFilters;





// WEBPACK FOOTER //
// ./src/myFilters.js